'use client';
import { useEffect, useRef, useState } from 'react';
import { useCopilot } from '../primitives/context.js';
/**
 * Park-envelope-until-idle dispatch shared verbatim by the memory- and
 * doc-share-suggestion cards (deep-code-analysis §3). The suggestion cards post
 * a follow-up user chat message (their "envelope") on Save/Confirm/Dismiss, but
 * `useChat.sendMessage` barfs when the agent's turn is still streaming, so the
 * envelope is queued and flushed the moment `isLoading` drops. Callers keep
 * building their own envelope payloads (wire shapes unchanged).
 */
export function useEnvelopeDispatch() {
    const { sendMessage, isLoading } = useCopilot();
    const [submitted, setSubmitted] = useState(null);
    const pendingEnvelopeRef = useRef(null);
    useEffect(() => {
        if (!isLoading && pendingEnvelopeRef.current !== null) {
            const envelope = pendingEnvelopeRef.current;
            pendingEnvelopeRef.current = null;
            sendMessage(envelope);
        }
    }, [isLoading, sendMessage]);
    const dispatchEnvelope = (envelope) => {
        if (isLoading) {
            pendingEnvelopeRef.current = envelope;
            return;
        }
        sendMessage(envelope);
    };
    return { dispatchEnvelope, submitted, setSubmitted };
}
//# sourceMappingURL=use-envelope-dispatch.js.map